import React, {Component} from 'react';

import {handleChange, handleValueChange, toggleState} from 'utils/ComponentUtilFunctions';
import FileUpload from 'components/FileUpload';
import Translate, {t} from 'components/Translate';
import Input from '../../../../../components/input-text';
import config from "../../../../../config";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../../components-new/buttons/SilverButton";
import DropdownSelect from "../../../../../components-new/DropdownSelect";

const customStyles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
};

class CreateClient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            domain: '',
            image: '',
            type: config.companyTypeMap.scenario,
            originalClient: {}
        };
        this.handleChange = handleChange.bind(this);
        this.handleValueChange = handleValueChange.bind(this);
        this.toggleState = toggleState.bind(this);
    }

    getClientFromState = () => {
        const {
            name, domain, image, type, originalClient
        } = this.state;
        return {
            name,
            domain,
            image,
            type,
            originalClientId: originalClient.id
        };
    };

    handleTypeChange = (event) => {
        this.setState({type: event.target.value});
    };

    render() {
        const {
            name, image, type, originalClient
        } = this.state;
        const {createClient, closeCreateClientModal, user, tariff, clients} = this.props;
        const {features} = tariff;

        return (
            <form onSubmit={(e) => {
                e.preventDefault();
                createClient(this.getClientFromState());
                this.setState({name: ""});
                window.location.reload();
            }}
            >
                <div className="create-client-body" style={customStyles.container}>
                    <h2 className={'title_feedback'}>
                        <Translate text="createNewBot"/>
                    </h2>
                    <br/>
                    <div
                        className="avatar-wrapper flex-container"
                        style={{
                            marginBottom: '40px',
                            alignContent: 'center',
                        }}
                    >
                        <p style={{
                            color: '#A4ADC1',
                            fontSize: '16px',
                            textAlign: 'center',
                            marginTop: '10px',
                            marginBottom: '5px'
                        }}
                        >
                            <Translate text={'uploadClientLogo/Symbol'}/>
                        </p>
                        <div>
                            <FileUpload
                                windowSize={44}
                                editIconSize={0}
                                editIconPos={0}
                                handleChange={this.handleValueChange('image')}
                                image={image}
                            />
                        </div>
                    </div>
                    <p style={{
                        color: '#A4ADC1',
                        fontSize: '16px',
                        textAlign: 'center',
                        marginTop: '10px',
                        marginBottom: '5px'
                    }}
                    ><Translate text={'botType'}/></p>
                    <DropdownSelect
                        options={[
                            {value: config.companyTypeMap.scenario, label: t({text: "scenario", user})},
                            ...(features.includes(config.features.AI)
                                ? [{value: config.companyTypeMap.smart, label: t({text: "smart", user})}]
                                : []),
                        ]}
                        selectedValue={type}
                        onChange={(newValue) => this.handleTypeChange({target: {value: newValue}})}
                        renderLabel={(value) => {
                            const typeOptions = {
                                [config.companyTypeMap.scenario]: t({text: "scenario", user}),
                                [config.companyTypeMap.smart]: t({text: "smart", user}),
                            };
                            return typeOptions[value] || t({text: "scenario", user});
                        }}
                        styles={{
                            borderRadius: '20px',
                            height: '45px',
                            width: '100%',
                        }}
                    />
                    {type === config.companyTypeMap.scenario && (
                        <React.Fragment>
                            <br/>
                            <p style={{
                                color: '#A4ADC1',
                                fontSize: '16px',
                                textAlign: 'center',
                                marginTop: '10px',
                                marginBottom: '5px'
                            }}
                            ><Translate text={'cloneFrom'}/></p>
                            <DropdownSelect
                                options={clients.filter(c => c.type === config.companyTypeMap.scenario)}
                                selectedValue={originalClient.name}
                                onChange={(event) => {
                                    this.setState({originalClient: event})
                                }}
                                renderLabel={() => {
                                    return originalClient.name
                                }}
                                styles={{
                                    borderRadius: '20px',
                                    height: '45px',
                                    width: '100%',
                                }}
                            />
                        </React.Fragment>

                    )}
                    <br/>
                    <div>
                        <p style={{
                            color: '#A4ADC1',
                            fontSize: '16px',
                            textAlign: 'center',
                            marginTop: '10px',
                            marginBottom: '5px'
                        }}
                        >
                            <Translate text={'botName'}/>
                        </p>
                        <Input
                            placeholder={t({text: "enterBotName*", user})}
                            debounceTime={0}
                            value={name}
                            maxLength={30}
                            handleChange={this.handleValueChange('name')}
                            inputStyles={{
                                marginBottom: '20px',
                                width: '100%',
                                height: '50px',
                            }}
                        />
                    </div>
                    <br/>
                    {type === config.companyTypeMap.smart && (
                        <div style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            <p style={{
                                color: '#A4ADC1',
                                fontSize: '12px',
                                textAlign: 'center',
                                marginTop: '10px',
                                maxWidth: '400px'
                            }}
                            >
                                <Translate text={'smartBotCreateInfo'}/>
                            </p>
                        </div>

                    )}
                    <br/>
                    <div style={{
                        color: '#09183A',
                        fontSize: '16px',
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                    >
                    </div>
                    <div style={{display: 'flex', gap: '20px', justifyContent: 'center'}}>
                        <SilverButton
                            type={'button'}
                            width={'135px'}
                            onClick={() => closeCreateClientModal()}
                            children={<Translate text={'cancel'}/>}
                        />
                        <BlueButton
                            disabled={name === ""}
                            type={'submit'}
                            width={'135px'}
                            children={<Translate text={'create'}/>}
                        />
                    </div>
                </div>
            </form>
        );
    }

}

CreateClient.propTypes = {
};

export default CreateClient;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/CreateClient.jsx